export default {
  switchLang(state, payload) {
    state.lang = payload;
    alert(`Mutation state.lang = payload:${state.lang}`);
  },
  setLang(state, payload) {
    state.lang = payload;
    alert(`Mutation setLang state.lang = payload:${state.lang}`);
  },
};
